import axios from "axios";
import Cookies from "js-cookie";
import {
  onRegistration,
  onTrialPurchased,
  onRegularFreeTrialActions,
  onCESignUpSubmit
} from "@/scripts/helpers/googleAnalyticsEvents";
import MicroModal from "micromodal";
import {
  initLoader,
  hideLoader
} from "@/modules/loader/loader";
import { CLASSES } from "@/scripts/helpers/constants";

export default () => {
  const body = $("body");
  const googleOneTap = $(".google-one-tap");
  const googleOneTapForm = $(".google-one-tap-forms");
  const token = $("meta[name='csrf-token']").attr("content");
  const pageUrl = window.location.href;
  const googleOtButton = $(".google-button");
  const tabletBreakpoint = 959;

  // exp-mkt-18725
    const sectionGoogleOneTap = $(".exp-mkt-18725");
    const sectionContainerGoogleOneTap = $("#google-one-tap-container");

    const introSectionScroll = () => {
      const contextIntroSection = document.querySelectorAll(".page-section--intro-one-tap");
      const contextFormWrapper = document.querySelectorAll(".page-section--intro-one-tap #google-one-tap-container");
      var introSectionHeight = contextIntroSection[0].clientHeight;

      const oneTapFixed = () => {
        const offsetTop = window.pageYOffset;

        if (offsetTop > introSectionHeight) {
          var introSectionFormWrapperHeight = contextFormWrapper[0].clientHeight;

          contextFormWrapper[0].style.height = `${introSectionFormWrapperHeight}px`;
          contextIntroSection[0].classList.add("intro-one-tap-fixed");
        } else {
          contextFormWrapper[0].style.height = "";
          contextIntroSection[0].classList.remove("intro-one-tap-fixed");
        }
      };

      window.addEventListener("scroll", () => oneTapFixed());
    };
  // exp-mkt-18725

  // exp-mkt-18387
    const countdownAfterStart = () => {
      var counter = 0;

      const addCounter = () => {
        const expRecallV4 = $(".exp-mkt-18387-v4");
        const expRecallV5 = $(".exp-mkt-18387-v5");

        counter++;

        if (expRecallV4.length) {
          if (counter > 3) {
            Cookies.remove("g_state");
            google.accounts.id.prompt()

            return;
          }
        } else if (expRecallV5.length) {
          if (counter > 3) {
            Cookies.remove("g_state");
            setTimeout(() => {
              google.accounts.id.prompt()
            }, 30000);

            return;
          }
        } else {
          if (counter > 3) {
            body.removeClass("exp-mkt-18387");

            return;
           }
        }

        startTimer();
      };
      const startTimer = () => {
        setTimeout(addCounter, 1000);
      };
      startTimer();
    };

    const oneTapRecall = () => {
      const expRecall = $(".exp-mkt-18387");
      const expRecallV1 = $(".exp-mkt-18387-v1");
      const expRecallV2 = $(".exp-mkt-18387-v2");
      const expRecallV3 = $(".exp-mkt-18387-v3");

      if (expRecall.length) {
        Cookies.remove("g_state");

        if (expRecallV1.length) {
          setTimeout(() => {
            google.accounts.id.prompt()
          }, 30000);
        } else if (expRecallV2.length) {
          setTimeout(() => {
            google.accounts.id.prompt()
          }, 45000);
        } else if (expRecallV3.length) {
          setTimeout(() => {
            google.accounts.id.prompt()
          }, 60000);
        }
      }
    };
  // exp-mkt-18387

  const oneTapShow = () => {
    Cookies.remove("g_state");
    
    google.accounts.id.prompt((notification) => {
      if (notification.isSkippedMoment() && notification.getSkippedReason() === 'user_cancel') {
        if ($(".alternative-one-tap-active").length) {
          body.removeClass("alternative-one-tap-active");
        }

        if (!$(".alternative-one-tap-show").length) {
          setTimeout(() => {
            body.addClass("alternative-one-tap-show");
          }, 900);
        }
      }
      
      if (notification.isDisplayMoment() || notification.isDisplayed()) {
        setTimeout(() => {
          body.removeClass("alternative-one-tap-show");
        }, 900);
      }
    });
  };

  if (googleOneTap.length) {
    window.onload = function() {
      Cookies.remove("g_state");

      const clientID =
        process.env.NODE_ENV === "production"
          ? "503458506158-ik55q8icsg2icen0t4qkr6a7uucoknug.apps.googleusercontent.com"
          : "799622306347-f6ahms0p90ub7o0cb2geqavlulinqr7d.apps.googleusercontent.com";

      // exp-mkt-18725
      if (sectionGoogleOneTap.length) {
        google.accounts.id.initialize({
          client_id: clientID,
          callback: handleCredentialResponse,
          cancel_on_tap_outside: false,
          prompt_parent_id: 'google-one-tap-container'
        });

      } else {
        google.accounts.id.initialize({
          client_id: clientID,
          callback: handleCredentialResponse,
          cancel_on_tap_outside: false
        });
      };
      // exp-mkt-18725

      google.accounts.id.prompt((notification) => {
        if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
          // The detailed reason why the UI isn't displayed.
          var detailedNotDisplayedReason = notification.getNotDisplayedReason();

          // exp-mkt-18387
          oneTapRecall();
          // exp-mkt-18387

          axios({
            method: "post",
            url: `/api/v1/metrics/google-one-tap-not-displayed`,
            data: {
              login_status: "isNotDisplayed",
              page_url: pageUrl,
              not_displayed_reason: detailedNotDisplayedReason
            },
            dataType: "json",
            headers: { "X-CSRF-TOKEN": token},
            withCredentials: false
          });

          const isDisplayedOneTap = $(".is-displayed-one-tap");

          if ($(window).width() > tabletBreakpoint && isDisplayedOneTap.length) {

            if ($(".is-displayed-one-tap").length) {
              body.removeClass("is-displayed-one-tap");
            }

            setTimeout(() => {
              body.addClass("alternative-one-tap-show");
            }, 600);

            googleOtButton.hover( function(e){
              const alternativeOneTapActive = $(".alternative-one-tap-active");
              
              if (!alternativeOneTapActive.length) {
                oneTapShow();

                e.preventDefault();
              };
              
              body.addClass("alternative-one-tap-active");
            });
          }
        } else {
          // exp-mkt-18725
          if (sectionGoogleOneTap.length) {
            introSectionScroll();
          }
          // exp-mkt-18725

          body.addClass("is-displayed-one-tap");

          // exp-mkt-18387
          if (!$(".is-displayed-one-tap").length) {
            countdownAfterStart();
          }
          // exp-mkt-18387

          axios({
            method: "post",
            url: `/api/v1/metrics/google-one-tap-show`,
            data: {
              login_status: "isDisplayed",
              page_url: pageUrl
            },
            dataType: "json",
            headers: { "X-CSRF-TOKEN": token},
            withCredentials: false
          });
        }
      });
    };

    function handleCredentialResponse(data) {
      axios({
        method: "post",
        url: `/api/v1/metrics/google-one-tap-click`,
        data: {
          login_status: true,
          page_url: pageUrl
        },
        dataType: "json",
        headers: { "X-CSRF-TOKEN": token},
        withCredentials: false
      });

      const alternativeBtnActive = $(".alternative-one-tap-active");

      if (alternativeBtnActive.length) {
        axios({
          method: "post",
          url: `/api/v1/metrics/google-one-tap-alternative-active`,
          data: {
            login_status: true,
            page_url: pageUrl
          },
          dataType: "json",
          headers: { "X-CSRF-TOKEN": token},
          withCredentials: false
        });
      };

      // initLoader($(".exp-18121"));

      const pathDomain =
        process.env.NODE_ENV === "production"
          ? ".signnow.com"
          : ".signnow-dev.xyz";

      Cookies.remove("XSRF-TOKEN", { secure: false, domain: `${pathDomain}` });

      const path =
        process.env.NODE_ENV === "production"
          ? "https://app.signnow.com/auth/v1/sessions/social"
          : "https://app3.signnow-dev.xyz/auth/v1/sessions/social";

      axios
        .post(
          path,
          {
            token: data.credential,
            provider: "google",
            login_source: "signnow_one_tap"
          },
          { withCredentials: true }
        )
        .then(res => {
          if (res.data.social_reg) {
            onRegistration();
            onTrialPurchased();
            onRegularFreeTrialActions("Google One Tap", "Sign-up");
            onCESignUpSubmit();
            axios({
              method: "post",
              url: `/event/google-one-tap-login-event`,
              data: {
                login_status: true,
                page_url: pageUrl,
                auth_type: "Sign-up"
              },
              dataType: "json",
              headers: { "X-CSRF-TOKEN": token},
              withCredentials: false
            });
          } else if (res.data.social_reg === false) {
            onRegularFreeTrialActions("Google One Tap", "Login");
            axios({
              method: "post",
              url: `/event/google-one-tap-login-event`,
              data: {
                login_status: true,
                page_url: pageUrl,
                auth_type: "Login"
              },
              dataType: "json",
              headers: { "X-CSRF-TOKEN": token},
              withCredentials: false
            });
          }

          const pathUrl =
            process.env.NODE_ENV === "production"
              ? "https://app.signnow.com/webapp/folder"
              : "https://app3.signnow-dev.xyz/webapp/folder";

          window.location.href = pathUrl;
        })
        .catch(error => {
          axios({
            method: "post",
            url: `/api/v1/metrics/google-one-tap-fail`,
            data: {
              login_status: false,
              page_url: pageUrl
            },
            dataType: "json",
            headers: { "X-CSRF-TOKEN": token},
            withCredentials: false
          });
        });
    }
  }

  if (googleOneTapForm.length) {
    window.onload = function() {
      Cookies.remove("g_state");
      
      const clientID =
        process.env.NODE_ENV === "production"
          ? "503458506158-ik55q8icsg2icen0t4qkr6a7uucoknug.apps.googleusercontent.com"
          : "799622306347-f6ahms0p90ub7o0cb2geqavlulinqr7d.apps.googleusercontent.com";

      google.accounts.id.initialize({
        client_id: clientID,
        callback: handleCredentialResponse,
        cancel_on_tap_outside: false
      });

      google.accounts.id.prompt((notification) => {        
        if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
          // The detailed reason why the UI isn't displayed.
          var detailedNotDisplayedReason = notification.getNotDisplayedReason();

          // exp-mkt-18387
          oneTapRecall();
          // exp-mkt-18387

          axios({
            method: "post",
            url: `/api/v1/metrics/google-one-tap-forms-not-displayed`,
            data: {
              login_status: "isNotDisplayedOnForms",
              page_url: pageUrl,
              not_displayed_reason: detailedNotDisplayedReason
            },
            dataType: "json",
            headers: { "X-CSRF-TOKEN": token},
            withCredentials: false
          });

          const isDisplayedOneTap = $(".is-displayed-one-tap");

          if ($(window).width() > tabletBreakpoint && isDisplayedOneTap.length) {

            if ($(".is-displayed-one-tap").length) {
              body.removeClass("is-displayed-one-tap");
            }

            setTimeout(() => {
              body.addClass("alternative-one-tap-show");
            }, 600);

            googleOtButton.hover( function(e){
              const alternativeOneTapActive = $(".alternative-one-tap-active");

              if (!alternativeOneTapActive.length) {
                oneTapShow();

                e.preventDefault();
              };
              
              body.addClass("alternative-one-tap-active");
            });
          }
        } else {
          body.addClass("is-displayed-one-tap");
          
          // exp-mkt-18387
          if (!$(".is-displayed-one-tap").length) {
            countdownAfterStart();
          }
          // exp-mkt-18387

          axios({
            method: "post",
            url: `/api/v1/metrics/google-one-tap-forms-show`,
            data: {
              login_status: "isDisplayedOnForms",
              page_url: pageUrl
            },
            dataType: "json",
            headers: { "X-CSRF-TOKEN": token},
            withCredentials: false
          });
        }
      });
    };

    function handleCredentialResponse(data) {
      axios({
        method: "post",
        url: `/api/v1/metrics/google-one-tap-forms-click`,
        data: {
          login_status: true,
          page_url: pageUrl
        },
        dataType: "json",
        headers: { "X-CSRF-TOKEN": token},
        withCredentials: false
      });

      const alternativeBtnActive = $(".alternative-one-tap-active");

      if (alternativeBtnActive.length) {
        axios({
          method: "post",
          url: `/api/v1/metrics/google-one-tap-alternative-active-forms`,
          data: {
            login_status: true,
            page_url: pageUrl
          },
          dataType: "json",
          headers: { "X-CSRF-TOKEN": token},
          withCredentials: false
        });
      };

      // initLoader($(".exp-18121"));

      const pathDomain =
        process.env.NODE_ENV === "production"
          ? ".signnow.com"
          : ".signnow-dev.xyz";

      Cookies.remove("XSRF-TOKEN", { secure: false, domain: `${pathDomain}` });

      const path =
        process.env.NODE_ENV === "production"
          ? "https://app.signnow.com/auth/v1/sessions/social"
          : "https://app3.signnow-dev.xyz/auth/v1/sessions/social";

      axios
        .post(
          path,
          {
            token: data.credential,
            provider: "google",
            login_source: "pdffiller_one_tap"
          },
          { withCredentials: true }
        )
        .then(res => {
          if (res.data.social_reg) {
            onRegistration();
            onTrialPurchased();
            onRegularFreeTrialActions("Google One Tap", "Sign-up");
            onCESignUpSubmit();
            axios({
              method: "post",
              url: `/event/google-one-tap-login-event`,
              data: {
                login_status: true,
                page_url: pageUrl,
                auth_type: "Sign-up"
              },
              dataType: "json",
              headers: { "X-CSRF-TOKEN": token},
              withCredentials: false
            });
          } else if (res.data.social_reg === false) {
            onRegularFreeTrialActions("Google One Tap", "Login");
            axios({
              method: "post",
              url: `/event/google-one-tap-login-event`,
              data: {
                login_status: true,
                page_url: pageUrl,
                auth_type: "Login"
              },
              dataType: "json",
              headers: { "X-CSRF-TOKEN": token},
              withCredentials: false
            });
          }

          const formId = $(
            ".page-section--greeting, .page-section--intro"
          ).attr("data-formId");
          
          const formLoader = () => {
            $.ajax({
              url: "/forms/get-editor-data",
              type: "POST",
              data: {
                id: formId
              },
              dataType: "json",
              headers: { "X-CSRF-TOKEN": token },

              success: function(data) {
                let editorUrl = data.editorUrl;
                setTimeout(() => {
                  window.location.href = editorUrl;
                }, 700);
              }
            });
          };

          $(".modal__button--back").click(function(e) {
            e.preventDefault();

            $.ajax({
              url: "/forms/get-editor-data",
              type: "POST",
              data: {
                id: formId
              },
              dataType: "json",
              headers: { "X-CSRF-TOKEN": token },
              success: function(data) {
                let editorUrl = data.editorUrl;

                setTimeout(() => {
                  window.open(editorUrl, "_blank");
                }, 700);
              }
            });
          });

          $(".modal__button--check").click(function(e) {
            axios({
              method: "post",
              url: `/api/v1/metrics/google-one-tap-popup-signnow`,
              data: {},
              dataType: "json",
              headers: { "X-CSRF-TOKEN": token},
              withCredentials: false
            });
          });

          if ($("#modal-successfully-registration").length) {
            MicroModal.show("modal-successfully-registration");
            hideLoader($(".exp-18121"));
          } else {
            formLoader();
          }
        })
        .catch(error => {
          axios({
            method: "post",
            url: `/api/v1/metrics/google-one-tap-forms-fail`,
            data: {
              login_status: false,
              page_url: pageUrl
            },
            dataType: "json",
            headers: { "X-CSRF-TOKEN": token},
            withCredentials: false
          });
        });
    }
  }
};
